import { useState, useEffect, useRef } from 'react';

export function useVideoPlayer({ durations }) {
  const durationsRef = useRef(durations);
  const keysRef = useRef(Object.keys(durations));
  const [sceneIndex, setSceneIndex] = useState(0);

  useEffect(() => {
    const keys = keysRef.current;
    const dur = durationsRef.current;
    const key = keys[sceneIndex];
    const timer = setTimeout(() => {
      setSceneIndex(i => (i + 1) % keys.length);
    }, dur[key]);
    return () => clearTimeout(timer);
  }, [sceneIndex]);

  return { currentScene: sceneIndex };
}
